import cellTypes from './cellTypes';

const switcher = ({ column, card }) => {
  switch (column.type) {
    case "checkbox":
      return cellTypes.MakeReadyCheckboxCell;
    case "textField":
      return cellTypes.MakeReadyTextInputCell;
    case "floor_plan":
      return cellTypes.MakeReadyTextCell;
    case "area":
      return cellTypes.MakeReadyTextCell;
    case "days_vacant":
      return cellTypes.MakeReadyTextCell;
    case "on_notice_resident_name":
      return cellTypes.MakeReadyTextCell;
    case "on_notice_resident_phone":
      return cellTypes.MakeReadyTextCell;
    case "newResidentName":
      return cellTypes.MakeReadyTextCell;
    case "newResidentPhoneNumber":
      return cellTypes.MakeReadyTextCell;
    case "marketRent":
      return cellTypes.MakeReadyTextCell;
    case "priorRent":
      return cellTypes.MakeReadyTextCell;
    case "monetaryField":
      return cellTypes.MakeReadyFloatInputCell;
    case "date":
      return cellTypes.MakeReadyDateInputCell;
    case "N/A":
      return cellTypes.MakeReadyNACell;
    case "inspection_template":
      return cellTypes.MakeReadyInspectionCell;
    case "tags":
      return cellTypes.MakeReadyTagsInputCell;
    default:
      if (card.hidden || card.completed_on) {
        return cellTypes.MakeReadyDisabledCell
      }
      return cellTypes.MakeReadyItemCell
  }
}

export default switcher;
